module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dfYcdr/tc-custom/9780062031389.jpg?1726454432765",
      "alt": "This image is the cover for the book Three Women"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Three Women\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Suzanne Blume has known success and disappointment in equal measure. A respected lawyer who survived two marriages and put two children through college, she now faces the disquieting prospect of her wayward older daughter moving back home. But more troubling still is the news that her mother, a woman of legendary independence who has never truly accepted her daughter nor approved of her choices, has been felled by age and illness. And, for the first time in her life, she needs Suzanne's help.")]), _c('p', [_vm._v("Intertwining the lives of three generations of contemporary women, master storyteller Marge Piercy plunges into the deepest, most elemental basics of life -- love, aging, illness, and death -- and emerges with a brave, compassionate exploration of the volatile ground between mothers and daughters.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marge Piercy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("&lt;p&gt;Marge Piercy is the author of the memoir Sleeping with Cats and fifteen novels, including &lt;em&gt;Three Women and Woman on the Edge of Time,&lt;/em&gt; as well as sixteen books of poetry, including &lt;em&gt;Colors Passing Through Us, The Art of Blessing the Day,&lt;/em&gt; and &lt;em&gt;Circles on the Water.&lt;/em&gt; She lives on Cape Cod, with her husband, Ira Wood, the novelist and publisher of Leapfrog Press.&lt;/p&gt;")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0